module.exports = __webpack_public_path__ + "media/state-press-3_2400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press-3_2400.jpg
// module id = 46
// module chunks = 0